import fetch from '@/utils/fetch'

export default {
  // 获取用户教育背景
  getEducationByAccountId: params => {
    params.sort = 'year,desc'
    return fetch({
      url: 'inquiry/educations',
      method: 'get',
      params
    })
  },
  // 保存单个教育背景
  saveEducation: data => {
    return fetch({
      url: 'educations/save',
      method: 'post',
      data
    })
  },
  // 保存全部教育背景
  saveAllEducation: data => {
    return fetch({
      url: 'educations/save-all',
      method: 'post',
      data
    })
  },
  // 删除单个教育背景
  deleteEducation: id => {
    return fetch({
      url: `educations/${id}`,
      method: 'delete'
    })
  },
  // 修改教育背景对外展示状态
  changeEducationOpen : () => {
    return fetch({
      url: 'users/education-open',
      method: 'put'
    })
  },
  // 获取用户奖项荣誉
  getAwardHonorByAccountId: params => {
    params.sort = 'year,desc'
    return fetch({
      url: 'inquiry/awardhonors',
      method: 'get',
      params
    })
  },
  // 保存单个奖项荣誉
  saveAwardHonor: data => {
    return fetch({
      url: 'awardhonors/save',
      method: 'post',
      data
    })
  },
  // 保存全部奖项荣誉
  saveAllAwardHonor: data => {
    return fetch({
      url: 'awardhonors/save-all',
      method: 'post',
      data
    })
  },
  // 删除单个奖项荣誉
  deleteAwardHonor: id => {
    return fetch({
      url: `awardhonors/${id}`,
      method: 'delete'
    })
  },
  // 修改奖项荣誉对外展示状态
  changeAwardHonorOpen : () => {
    return fetch({
      url: 'users/award-open',
      method: 'put'
    })
  },
  // 获取用户工作履历
  getExperienceByAccountId: params => {
    params.sort = 'startYear,desc'
    return fetch({
      url: 'inquiry/workexperiences',
      method: 'get',
      params
    })
  },
  // 保存单个工作履历
  saveExperience: data => {
    return fetch({
      url: 'workexperiences/save',
      method: 'post',
      data
    })
  },
  // 保存全部工作履历
  saveAllExperience: data => {
    return fetch({
      url: 'workexperiences/save-all',
      method: 'post',
      data
    })
  },
  // 删除单个工作履历
  deleteExperience: id => {
    return fetch({
      url: `workexperiences/${id}`,
      method: 'delete'
    })
  },
  // 修改工作履历对外展示状态
  changeExperienceOpen : () => {
    return fetch({
      url: 'users/work-open',
      method: 'put'
    })
  },
  // 获取用户论文著作
  getPaperByAccountId: params => {
    params.sort = 'year,desc'
    return fetch({
      url: 'inquiry/publications',
      method: 'get',
      params
    })
  },
  // 保存单个工作履历
  savePaper: data => {
    return fetch({
      url: 'publications/save',
      method: 'post',
      data
    })
  },
  // 保存全部工作履历
  saveAllPaper: data => {
    return fetch({
      url: 'publications/save-all',
      method: 'post',
      data
    })
  },
  // 删除单个工作履历
  deletePaper: id => {
    return fetch({
      url: `publications/${id}`,
      method: 'delete'
    })
  },
  // 修改工作履历对外展示状态
  changePaperOpen : () => {
    return fetch({
      url: 'users/publication-open',
      method: 'put'
    })
  },
  // 获取用户专业资质
  getQualificationByAccountId: params => {
    params.sort = 'endYear,desc'
    return fetch({
      url: 'inquiry/qualifications',
      method: 'get',
      params
    })
  },
  // 保存单个专业资质
  saveQualification: data => {
    return fetch({
      url: 'qualifications/save',
      method: 'post',
      data
    })
  },
  // 保存全部专业资质
  saveAllQualification: data => {
    return fetch({
      url: 'qualifications/save-all',
      method: 'post',
      data
    })
  },
  // 删除单个专业资质
  deleteQualification: id => {
    return fetch({
      url: `qualifications/${id}`,
      method: 'delete'
    })
  },
  // 修改专业资质对外展示状态
  changeQualificationOpen : () => {
    return fetch({
      url: 'users/qualification-open',
      method: 'put'
    })
  },
  // 获取用户媒体曝光
  getMediaByAccountId: params => {
    params.sort = 'year,desc'
    return fetch({
      url: 'inquiry/mediareports',
      method: 'get',
      params
    })
  },
  // 保存单个媒体曝光
  saveMedia: data => {
    return fetch({
      url: 'mediareports/save',
      method: 'post',
      data
    })
  },
  // 保存全部媒体曝光
  saveAllMedia: data => {
    return fetch({
      url: 'mediareports/save-all',
      method: 'post',
      data
    })
  },
  // 删除单个媒体曝光
  deleteMedia: id => {
    return fetch({
      url: `mediareports/${id}`,
      method: 'delete'
    })
  },
  // 修改媒体曝光对外展示状态
  changeMediaOpen : () => {
    return fetch({
      url: 'users/media-open',
      method: 'put'
    })
  },
  // 获取用户社会任职
  getServiceByAccountId: params => {
    params.sort = 'startYear,desc'
    return fetch({
      url: 'inquiry/socialservices',
      method: 'get',
      params
    })
  },
  // 保存单个社会任职
  saveService: data => {
    return fetch({
      url: 'socialservices/save',
      method: 'post',
      data
    })
  },
  // 保存全部社会任职
  saveAllService: data => {
    return fetch({
      url: 'socialservices/save-all',
      method: 'post',
      data
    })
  },
  // 删除单个社会任职
  deleteService: id => {
    return fetch({
      url: `socialservices/${id}`,
      method: 'delete'
    })
  },
  // 修改社会任职对外展示状态
  changeServiceOpen : () => {
    return fetch({
      url: 'users/service-open',
      method: 'put'
    })
  },
  // 获取用户社会活动
  getActivityByAccountId: params => {
    params.sort = 'date,desc'
    return fetch({
      url: 'inquiry/socialactivities',
      method: 'get',
      params
    })
  },
  // 保存单个社会活动
  saveActivity: data => {
    return fetch({
      url: 'socialactivities/save',
      method: 'post',
      data
    })
  },
  // 保存全部社会活动
  saveAllActivity: data => {
    return fetch({
      url: 'socialactivities/save-all',
      method: 'post',
      data
    })
  },
  // 删除单个社会活动
  deleteActivity: id => {
    return fetch({
      url: `socialactivities/${id}`,
      method: 'delete'
    })
  },
  // 修改社会活动对外展示状态
  changeActivityOpen : () => {
    return fetch({
      url: 'users/activity-open',
      method: 'put'
    })
  },
  // 更新基本信息
  updateBasicInfo: data => {
    return fetch({
      url: 'users',
      method: 'put',
      data
    })
  },
  // 修改地址对外展示状态
  changeAddressOpen: () => {
    return fetch({
      url: 'users/address-open',
      method: 'put'
    })
  },
  // 修改邮箱对外展示状态
  changeEmailOpen: () => {
    return fetch({
      url: 'users/email-open',
      method: 'put'
    })
  },
  // 修改微博对外展示状态
  changeWeiboOpen: () => {
    return fetch({
      url: 'users/weibo-open',
      method: 'put'
    })
  },
  // 修改电话对外展示状态
  changePhoneOpen: () => {
    return fetch({
      url: 'users/phone-open',
      method: 'put'
    })
  },
  // 保存作品信息
  saveProject: data => {
    return fetch({
      url: 'projects/save',
      method: 'post',
      data
    })
  },
  // 获取单个作品信息
  getOneProject: id => {
    return fetch({
      url: `inquiry/projects/${id}`,
      method: 'get'
    })
  },
  // 获取作品列表
  getProjects: params => {
    return fetch({
      url: 'inquiry/projects',
      method: 'get',
      params
    })
  },
  // 删除单个作品
  deleteOneProject: id => {
    return fetch({
      url: `projects/${id}`,
      method: 'delete'
    })
  },
  // 修改作品对外展示状态
  changeProjectOpen : () => {
    return fetch({
      url: 'users/project-open',
      method: 'put'
    })
  },
}